// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"821":"7b3b2b1a","832":"e47c6908","833":"b7f3d6cb"}[chunkId] + ".chunk.js";
};